import axios from 'axios';

// API URL için önce environment variable'ı kontrol et, yoksa localhost kullan
const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5196';
const baseURL = envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;

console.log('API URL:', baseURL);

const axiosInstance = axios.create({
    baseURL,
    timeout: 10000, // Timeout'u 10 saniyeye çıkarıyoruz
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // Request gönderilmeden önce yapılacak işlemler
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('Request gönderilirken hata oluştu:', error);
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        // Başarılı yanıtları doğrudan döndür
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Token expire olduğunda
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('refreshToken');
                
                if (!refreshToken) {
                    throw new Error('Refresh token bulunamadı');
                }
                
                const response = await axios.post(`${baseURL}/auth/refresh-token`, {
                    refreshToken
                });

                const { token } = response.data;
                
                if (!token) {
                    throw new Error('Yeni token alınamadı');
                }
                
                localStorage.setItem('token', token);

                originalRequest.headers.Authorization = `Bearer ${token}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                console.error('Token yenileme hatası:', refreshError);
                
                // Kullanıcı oturumunu temizle
                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('user');
                
                // Kullanıcıyı login sayfasına yönlendir
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }
        
        // API'den gelen hata mesajlarını işle
        const errorMessage = error.response?.data?.message || 
                            error.response?.data?.error || 
                            error.message || 
                            'Bir hata oluştu';
        
        // Hata koduna göre özel işlemler
        switch (error.response?.status) {
            case 404:
                console.error('Kaynak bulunamadı:', errorMessage);
                break;
            case 403:
                console.error('Yetkisiz erişim:', errorMessage);
                break;
            case 500:
                console.error('Sunucu hatası:', errorMessage);
                break;
            default:
                console.error('API hatası:', errorMessage);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance; 